import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

interface LawyerMyMattersParams {
  /** Server-side role filter — omit for all my matters. */
  role?: 'LEAD' | 'CONTRIBUTOR';
  /** Page size — the card grows it by 10 per "Show more" click. */
  limit?: number;
  enabled?: boolean;
}

export function useLawyerMyMatters({ role, limit = 10, enabled = true }: LawyerMyMattersParams = {}) {
  return useQuery({
    queryKey: dashboardQueryKeys.lawyerMyMatters(role, limit),
    queryFn: () => dashboardApi.getLawyerMyMatters({ limit, role }),
    enabled,
    // Keep the current rows on screen while a filter/Show-more refetch runs.
    placeholderData: keepPreviousData,
  });
}
